<template>
<div >
  <v-layout justify-center mt-10>
 <h4>Manage Quick Connect Questions</h4> 
   <v-row justify="center">
   <v-dialog
      v-model="newQuestionDialog"
      persistent
      max-width="600px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          class="m4u_text--text"
          v-bind="attrs"
          v-on="on"
        >
          New Question
        </v-btn>
      </template>
      <v-card>
        <v-card-title>
          <span class="text-h5">New Quick Connect Question</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                cols="12"
              >
                <v-text-field
                v-model="qcDate"
                  label="Date"
                  hint="YYYY-MM-DD"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
              >
                <v-text-field
                  v-model="qcQuestion"
                  label="Question"
                ></v-text-field>
              </v-col>

            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="teal"
            text
            @click="newQuestionDialog = false"
          >
            Close
          </v-btn>
          <v-btn
            color="teal"
            text
            @click="addQuestion()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> 


   </v-row>

  </v-layout>
    <div v-for="question in questions" :key="question.ViewPointID">
   <QCManageCard :question="question" @refreshQuestions="getQuestions"/>
   </div>

</div>

</template>
<script>

import EventService from '@/services/EventService.js'; 
import QCManageCard from '../components/QCManageCard.vue'; 

export default {
  name: 'quickconnectmanage',

  data() {
    return {
        questions: [],
        editQuestion: [],
        newQuestionDialog: false,
        editQuestionDialog: false,
        qcQuestion: '',
        qcDate: '',

       }
    },
  
  components: {
    QCManageCard
  },
  
mounted() {
    this.getQuestions();
  },


computed: {
  user(){
    return this.$store.state.user
  }
},

  loginState(){
    return this.$store.state.loginState
  },

  methods: {
    onScroll (e) {
      if (typeof window === 'undefined') return
      const top = window.pageYOffset ||   e.target.scrollTop || 0
      this.fab =  top > 10
    },
    toTop () {
      this.$vuetify.goTo(0)
    },

    async getQuestions() {

      await EventService.getAllQuickConnectQuestions()
      .then(
        (questions => {
          this.$set(this, "questions", questions);
        }).bind(this)

      );
    },

    async addQuestion() {
      await EventService.addQuickConnectQuestion(this.qcDate, this.qcQuestion, this.user.UserID)
      .then(() => {
          this.newQuestionDialog = false;
          this.getQuestions();
      }
      );
    },

 
    async deleteQuestion(question) {
      await EventService.deleteQuickConnectQuestion(question.ViewPointID)
      .then(
        async () => {
          this.getQuestions();
        }
      );
    },
    async getThisQCQuestion(question) {
       this.editQuestionDialog = true;
      await EventService.getThisQCQuestion(question.ViewPointID)
      .then(
        (question => {
          this.$set(this, "editQuestion", question[0]);
        }).bind(this)
      );
    },

      async saveQuestion(ViewPointID) {
        this.editQuestionDialog = false
      await EventService.editThisQCQuestion(ViewPointID, this.editQuestion.ViewPointQ, this.editQuestion.ViewPointDate, this.user.UserID)
      .then(
        (questionreply => {
          this.getQuestions();
        })

      );
    },

  }

}


</script>
<style lang="scss" scoped>
  .bookButton {
    overflow: hidden;
    height: auto;
      width: auto;
  }
  .bookDiv {
  border: solid;
  border-width: 8px;
  border-color: #FFCB47;
  background-color: white;
  padding: 20px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  max-height: 80%;
  margin: 1em;
  border-radius: 5%;
  background-image: url('/public/bookbackground.png');
  }

  .bookList {
    max-height: 20%;
    scroll-behavior: auto;
  }

  .bookSelector {
    justify-content: center;

  }

  .formCard {
    max-width: 80%;
    justify-content: center;
  }

.rtl {
  direction: rtl;
}
  .toggleButtons {
    margin-bottom: 1em;
    margin-top: 1.25em;

  }

  .outerDiv {
    background-color: white;
  }

 .warningtext {
   font-size: 1.25em;
 }


</style>